module.exports = __webpack_public_path__ + "img/GTM-integration-vidjet-step6-FR.b6b1f239.png";